"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getYearlyCoordinates = exports.getProductionFields = exports.getMonthlyCoordinates = exports.getMonthByWeeklyCoordinates = exports.getHourlyCoordinates = exports.getBatteryFields = exports.getBatteryCoordinates = exports.formatSiteProductionData = exports.formatBatteryHourlyData = void 0;

var _luxon = require("luxon");

var _ = require(".");

var _chartUtils = require("../chartUtils");

var ChartRanges = _interopRequireWildcard(require("../constants/chartRanges"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var createKey = function createKey(dt) {
  return dt.startOf('hour').toISO();
};

var getHourlyCoordinates = function getHourlyCoordinates(productionData, dateISO, zone) {
  var startDate = _luxon.DateTime.fromISO(dateISO, {
    zone: zone
  }).startOf('day');

  var endDate = _luxon.DateTime.fromISO(dateISO, {
    zone: zone
  }).endOf('day');

  var readingDictionary = productionData.reduce(function (dictionary, reading) {
    var id = createKey(_luxon.DateTime.fromISO(reading.readingEndTimeLocal, {
      zone: zone
    }));
    dictionary[id] = reading;
    return dictionary;
  }, {});
  var hours = (0, _.getDatesBetween)({
    startDate: startDate,
    endDate: endDate
  }, {
    minute: 0,
    second: 0
  }, 'hour');
  var coordinates = hours.map(function (dt) {
    var x = createKey(dt);

    var _DateTime$fromISO = _luxon.DateTime.fromISO(x, {
      zone: zone
    }),
        hour = _DateTime$fromISO.hour;

    return {
      x: "".concat(x.split('T')[0], " ").concat(hour, ":00"),
      y: readingDictionary[x] && !isNaN(readingDictionary[x].deliveredKwh) ? +Number(readingDictionary[x].deliveredKwh).toFixed(3) : 0
    };
  });
  return coordinates;
};

exports.getHourlyCoordinates = getHourlyCoordinates;

var getMonthlyCoordinates = function getMonthlyCoordinates(productionData, startDate, endDate, zone, today) {
  var readingDictionary = productionData.reduce(function (dictionary, reading) {
    var id = _luxon.DateTime.fromISO(reading.readingEndTimeLocal, {
      zone: zone
    }).toISODate();

    dictionary[id] = reading;
    return dictionary;
  }, {});
  var datesBetween = (0, _.getDatesBetween)({
    startDate: startDate,
    endDate: today || endDate
  }, {
    hour: 23,
    minute: 59,
    second: 59
  }, 'days');
  var coordinates = datesBetween.map(function (dt) {
    var isoDate = dt.toISODate();
    var y = readingDictionary[isoDate] && (0, _chartUtils.isNumeric)(readingDictionary[isoDate].deliveredKwh) ? +Number(readingDictionary[isoDate].deliveredKwh).toFixed(3) : 0;
    var y0 = readingDictionary[isoDate] && (0, _chartUtils.isNumeric)(readingDictionary[isoDate].cumulativeKwh) ? +Number(readingDictionary[isoDate].cumulativeKwh).toFixed(3) : 0;
    return {
      x: isoDate,
      y: y,
      y0: y0
    };
  });
  return coordinates;
};

exports.getMonthlyCoordinates = getMonthlyCoordinates;

var getMonthByWeeklyCoordinates = function getMonthByWeeklyCoordinates(productionData, zone) {
  // eslint-disable-next-line prefer-spread
  var downloadCoordinates = [].concat.apply([], productionData);
  downloadCoordinates.map(function (obj) {
    obj.x = _luxon.DateTime.fromISO(obj.x, {
      zone: zone
    }).toISODate();
    return obj;
  });
  return downloadCoordinates;
};

exports.getMonthByWeeklyCoordinates = getMonthByWeeklyCoordinates;

var getYearlyCoordinates = function getYearlyCoordinates(productionData, year, zone, todayDateTime) {
  var readingDictionary = productionData.reduce(function (dictionary, reading) {
    var id = _luxon.DateTime.fromISO(reading.readingEndTimeLocal, {
      zone: zone
    }).toISODate();

    dictionary[id] = reading;
    return dictionary;
  }, {});
  var lastDayOfEachMonth = (0, _.getDatesBetween)({
    startDate: _luxon.DateTime.fromObject({
      day: 31,
      month: 1,
      year: year
    }, {
      zone: zone
    }),
    endDate: _luxon.DateTime.fromObject({
      day: todayDateTime.daysInMonth,
      month: Number(todayDateTime.toFormat('MM')),
      year: year
    }, {
      zone: zone
    })
  }, {
    hour: 23,
    minute: 59,
    second: 59
  }, 'months');
  var coordinates = lastDayOfEachMonth.map(function (dt) {
    var isoDate = dt.toISODate();
    var y = readingDictionary[isoDate] && (0, _chartUtils.isNumeric)(readingDictionary[isoDate].deliveredKwh) ? +Number(readingDictionary[isoDate].deliveredKwh).toFixed(3) : 0;
    return {
      x: isoDate,
      y: y,
      y0: 0
    };
  });
  return coordinates;
};

exports.getYearlyCoordinates = getYearlyCoordinates;

var getBatteryCoordinates = function getBatteryCoordinates(data, dateISO, zone, range) {
  var startDate = _luxon.DateTime.fromISO(dateISO, {
    zone: zone
  }).startOf('day');

  var endDate = range === 'weekly' ? _luxon.DateTime.fromISO(dateISO, {
    zone: zone
  }).plus({
    days: 7
  }).endOf('day') : _luxon.DateTime.fromISO(dateISO, {
    zone: zone
  }).endOf('day');
  var batteryDictionary = data.reduce(function (dictionary, reading) {
    var id = createKey(_luxon.DateTime.fromISO(reading.timeStamp, {
      zone: zone
    }));
    dictionary[id] = reading;
    return dictionary;
  }, {});
  var hours = (0, _.getDatesBetween)({
    startDate: startDate,
    endDate: endDate
  }, {
    minute: 0,
    second: 0
  }, 'hour');
  var batteryCoordinates = hours.map(function (dt) {
    var x = createKey(dt);
    return {
      x: x,
      y: batteryDictionary[x] && !isNaN(batteryDictionary[x].batteryPercentAverage) ? +Number(batteryDictionary[x].batteryPercentAverage).toFixed(3) : 0,
      y0: 0
    };
  });
  return batteryCoordinates;
};

exports.getBatteryCoordinates = getBatteryCoordinates;

var formatSiteProductionData = function formatSiteProductionData(fields, rows) {
  return rows.map(function (row) {
    var _ref;

    return _ref = {}, _defineProperty(_ref, fields[0], row.x), _defineProperty(_ref, fields[1], row.y), _defineProperty(_ref, fields[2], row.y0), _ref;
  });
};

exports.formatSiteProductionData = formatSiteProductionData;

var formatBatteryHourlyData = function formatBatteryHourlyData(fields, rows) {
  var _columns;

  var data = rows.map(function (row) {
    var _ref2;

    return _ref2 = {}, _defineProperty(_ref2, fields[0], row.x), _defineProperty(_ref2, fields[1], row.y), _ref2;
  });
  var columns = (_columns = {}, _defineProperty(_columns, fields[0], 'Date'), _defineProperty(_columns, fields[1], 'Battery Percent'), _columns);
  data.unshift(columns);
  return data;
};

exports.formatBatteryHourlyData = formatBatteryHourlyData;

var getProductionFields = function getProductionFields(range) {
  var nonDailyRanges = [ChartRanges.YESTERDAY, ChartRanges.LASTSIXMONTHS, ChartRanges.YEARTODATE];
  var fields = ['Date', 'Solar Produced (kWh)'];

  if (!nonDailyRanges.includes(range)) {
    fields.push('End-of-Day Meter Reading (kWh)');
  }

  return fields;
};

exports.getProductionFields = getProductionFields;

var getBatteryFields = function getBatteryFields(startDate, endDate, zone) {
  var startISODate = _luxon.DateTime.fromISO(startDate, {
    zone: zone
  }).toISODate();

  var endISODate = _luxon.DateTime.fromISO(endDate, {
    zone: zone
  }).toISODate();

  return ['Battery Usage', "".concat(startISODate, " - ").concat(endISODate), 'Sunrun.com'];
};

exports.getBatteryFields = getBatteryFields;